"use strict";
export var PositionField = /* @__PURE__ */ ((PositionField2) => {
  PositionField2["TOKEN0"] = "TOKEN0";
  PositionField2["TOKEN1"] = "TOKEN1";
  return PositionField2;
})(PositionField || {});
